module.exports = __webpack_public_path__ + "static/screen-classic-mac-laptop@2x-4aaa9bed437b00dfd07e2c0be941d06d.png";